import { Form, type FormItemProps, Select, type SelectProps } from 'antd';

import type { Ii18nLabel } from '@/types/common';
import { getTranslatedString } from '@/utils';

import { getFormItemLabel } from './utils';

const { Option } = Select;

interface DropdownProps extends SelectProps<any>, FormItemProps, Partial<Ii18nLabel> {
  children?: any;
  i18nExtra?: string;
}

export function Dropdown({
  allowClear = true,
  options,
  name,
  label,
  i18nLabel,
  rules,
  showSearch = true,
  optionFilterProp = 'children',
  i18nExtra,
  extra,
  ...props
}: DropdownProps) {
  const fieldLabel = getFormItemLabel(i18nLabel, label);
  const extraNode = extra ?? (i18nExtra ? getTranslatedString(i18nExtra) : undefined);

  return (
    <Form.Item name={name} label={fieldLabel} rules={rules} extra={extraNode}>
      <Select {...props} allowClear={allowClear} showSearch={showSearch} optionFilterProp={optionFilterProp}>
        {options.map((item: any) => (
          <Option key={item.value} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}
